import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

import { fetchAuthSession } from 'aws-amplify/auth'

function trimStr(v) {
  return typeof v === 'string' ? v.trim() : ''
}

/**
 * AppSync HTTP URL. In dev, `/graphql` is proxied by Vite when .env has the full AppSync URL.
 */
function getAppSyncGraphqlUri() {
  const raw =
    trimStr(import.meta.env.VITE_APPSYNC_GRAPHQL_ENDPOINT) ||
    trimStr(import.meta.env.VITE_REACT_APP_APPSYNC_GRAPHQL_ENDPOINT) ||
    ''

  if (raw.startsWith('https://') || raw.startsWith('http://')) {
    return raw
  }
  if (import.meta.env.DEV && (!raw || raw === '/graphql')) {
    return '/graphql'
  }
  if (raw.startsWith('/') && typeof window !== 'undefined') {
    return `${window.location.origin}${raw}`
  }
  return raw
}

const resolvedGraphqlUri = getAppSyncGraphqlUri()
const graphqlUri = resolvedGraphqlUri || (import.meta.env.DEV ? '/graphql' : null)

if (!graphqlUri) {
  console.error(
    '[Apollo] Missing VITE_APPSYNC_GRAPHQL_ENDPOINT (full AppSync URL, typically …appsync-api.us-west-1.amazonaws.com/graphql).'
  )
}

const graphqlApiKey =
  trimStr(import.meta.env.VITE_GRAPHQL_API_KEY) ||
  trimStr(import.meta.env.VITE_REACT_APP_GRAPHQL_API_KEY) ||
  ''

const httpLink = createHttpLink({
  uri:
    graphqlUri ?? 'https://missing-vite-appsync-graphql-endpoint.invalid/graphql',
})

const authLink = setContext(async (_, { headers }) => {
  const base = { ...headers }
  try {
    const { tokens } = await fetchAuthSession()
    const token = tokens?.idToken?.toString()

    if (token) {
      return {
        headers: {
          ...base,
          authorization: token,
        },
      }
    }
  } catch (error) {
    console.error('Error in auth context link:', error)
  }
  return {
    headers: {
      ...base,
      ...(graphqlApiKey ? { 'x-api-key': graphqlApiKey } : {}),
    },
  }
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: import.meta.env.NODE_ENV !== 'production',
})

export default client
